// extracted by mini-css-extract-plugin
export default {"label":"ExternalUsers_label__AmJsm"};